// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Transportinpune() {



const cardData = {


    keyword: "Transporters in Pune",

    headingDescription: "SSK Logistic supports businesses searching for dependable transporters in Pune with organized goods transportation, freight movement, cargo delivery, industrial transportation, commercial distribution, truck transport, container movement, heavy cargo support, and full truck load transportation. The service is designed for manufacturers, distributors, wholesalers, retailers, warehouses, corporate businesses, industrial units, and traders that require practical movement of goods from Pune to major destinations across Maharashtra and other parts of India. SSK Logistic coordinates transportation according to cargo type, vehicle requirements, route distance, loading conditions, shipment schedules, and delivery locations, helping businesses manage regular and one-time transportation requirements through a structured logistics partner.",

    topPlaces: [
        {
            title: "Pune to Chakan Industrial Transportation",
            description: "SSK Logistic supports industrial transportation from Pune to Chakan for manufacturing units, automotive suppliers, factories, warehouses, and industrial businesses. Transportation can be coordinated for machinery, components, raw materials, finished products, and recurring factory dispatches according to operational schedules."
        },
        {
            title: "Pune to Bhiwandi Goods Transportation",
            description: "Goods transportation from Pune to Bhiwandi supports businesses moving warehouse inventory, commercial products, industrial materials, and distribution consignments. SSK Logistic coordinates suitable vehicles and delivery schedules for businesses connecting Pune with this major warehousing and logistics market."
        },
        {
            title: "Pune to Mumbai Freight Transportation",
            description: "Freight transportation between Pune and Mumbai is suitable for manufacturers, distributors, traders, and corporate businesses moving commercial and industrial consignments. SSK Logistic coordinates practical transportation arrangements according to cargo requirements, route schedules, and destination locations."
        },
        {
            title: "Pune to Nashik Cargo Transportation",
            description: "Cargo transportation from Pune to Nashik helps businesses move industrial goods, machinery, commercial inventory, raw materials, and distribution stock. SSK Logistic provides route-focused transportation coordination based on shipment characteristics, vehicle requirements, and expected delivery timelines."
        },
        {
            title: "Pune to Surat Commercial Transportation",
            description: "Commercial transportation from Pune to Surat supports retailers, wholesalers, manufacturers, and traders moving inventory, textile-related goods, equipment, and commercial consignments. SSK Logistic coordinates transportation according to cargo volume, route distance, and delivery requirements."
        },
        {
            title: "Pune to Ahmedabad Truck Transportation",
            description: "Truck transportation from Pune to Ahmedabad is suitable for larger commercial and industrial loads requiring organized interstate movement. SSK Logistic assists with vehicle coordination and transportation planning based on cargo size, loading needs, route requirements, and scheduled delivery."
        },
        {
            title: "Pune to Hyderabad Goods Transport",
            description: "Goods transport from Pune to Hyderabad supports interstate movement of machinery, commercial products, industrial materials, warehouse stock, and business consignments. SSK Logistic coordinates long-distance transportation with practical route and delivery planning."
        },
        {
            title: "Pune to Indore Freight Transport",
            description: "Freight transport from Pune to Indore provides businesses with transportation support for commercial inventory, industrial materials, machinery, finished products, and distribution cargo. SSK Logistic plans suitable vehicle arrangements around shipment size and delivery schedules."
        },
        {
            title: "Pune to Bengaluru Industrial Transport",
            description: "Industrial transport from Pune to Bengaluru helps manufacturers, suppliers, distributors, and commercial businesses move components, machinery, products, and industrial materials. SSK Logistic coordinates long-distance transportation according to cargo requirements and business schedules."
        },
        {
            title: "Pune to Delhi NCR Full Truck Load Transport",
            description: "Full truck load transport from Pune to Delhi NCR is suitable for businesses requiring dedicated vehicle capacity for larger consignments. SSK Logistic coordinates FTL movement according to cargo volume, loading requirements, route distance, and planned delivery schedules."
        }
    ],

    "services": [
        {
            "name": "Transporters in Pune",
            "description": "SSK Logistic supports businesses searching for transporters in Pune with organized movement of goods, freight, cargo, industrial materials, machinery, and commercial inventory. Transportation can be coordinated for local, regional, and interstate routes according to shipment and delivery requirements."
        },
        {
            "name": "Best Transporters in Pune",
            "description": "Businesses researching best transporters in Pune can consider SSK Logistic for structured goods transportation, freight movement, cargo delivery, truck transportation, and industrial logistics support. Services are planned around practical vehicle requirements, route distance, and business delivery schedules."
        },
        {
            "name": "Transporters Near Pune",
            "description": "Companies searching for transporters near Pune can use SSK Logistic for transportation between factories, warehouses, markets, distribution centers, and destinations across Maharashtra and other states. Local and long-distance transportation can be organized according to business requirements."
        },
        {
            "name": "Reliable Transporters Pune",
            "description": "SSK Logistic provides transportation support for businesses looking for reliable transporters Pune for commercial goods, industrial materials, freight, machinery, and warehouse inventory. Planned coordination helps businesses manage recurring and individual transportation requirements."
        },
        {
            "name": "Goods Transporters Pune",
            "description": "Goods transporters Pune services from SSK Logistic support manufacturers, distributors, retailers, wholesalers, and traders moving raw materials, finished products, equipment, and commercial inventory. Transportation arrangements are planned around cargo quantity, destination, and delivery schedules."
        },
        {
            "name": "Truck Transporters Pune",
            "description": "SSK Logistic supports truck transporters Pune requirements with coordinated transportation for commercial and industrial loads. Vehicle planning can be matched to cargo quantity, loading requirements, route distance, and delivery locations for both regular and one-time shipments."
        },
        {
            "name": "Freight Transporters Pune",
            "description": "Freight transporters Pune services from SSK Logistic are suitable for businesses moving larger commercial and industrial consignments. Transportation is coordinated according to freight dimensions, shipment quantity, vehicle requirements, route distance, and destination delivery needs."
        },
        {
            "name": "Cargo Transporters Pune",
            "description": "Businesses requiring cargo transporters Pune can coordinate with SSK Logistic for organized movement of machinery, commercial products, industrial supplies, warehouse stock, and other cargo. Pickup, transportation, route planning, and delivery requirements can be coordinated as part of the service."
        },
        {
            "name": "Industrial Transporters Pune",
            "description": "SSK Logistic supports industrial transporters Pune requirements for factories, manufacturing units, industrial suppliers, and infrastructure businesses moving machinery, raw materials, components, equipment, and finished goods. Transportation can be aligned with production and dispatch schedules."
        },
        {
            "name": "Commercial Transporters Pune",
            "description": "Commercial transporters Pune services from SSK Logistic assist retailers, wholesalers, distributors, traders, and corporate businesses with planned movement of inventory and commercial consignments. Vehicle and route arrangements are coordinated according to shipment and delivery requirements."
        },
        {
            "name": "Container Transporters Pune",
            "description": "SSK Logistic provides container transporters Pune support for businesses requiring organized movement of containerized cargo between factories, warehouses, distribution facilities, and commercial destinations. Transportation planning considers container requirements, route conditions, and delivery schedules."
        },
        {
            "name": "Road Transporters Pune",
            "description": "Road transporters Pune services from SSK Logistic provide businesses with practical ground transportation for local, regional, and interstate cargo movement. The service is suitable for commercial inventory, industrial materials, freight, machinery, and warehouse transfers."
        },
        {
            "name": "Heavy Transporters Pune",
            "description": "Businesses requiring heavy transporters Pune can coordinate with SSK Logistic for movement of large or heavy industrial consignments. Transportation planning considers cargo dimensions, weight, loading requirements, route conditions, and destination-specific delivery arrangements."
        },
        {
            "name": "Full Truck Load Transporters Pune",
            "description": "Full truck load transporters Pune services from SSK Logistic are designed for businesses requiring dedicated vehicle capacity for larger shipments. FTL arrangements can be planned according to cargo volume, loading schedule, destination, route distance, and required delivery timeframe."
        },
        {
            "name": "Local Transporters Pune",
            "description": "Local transporters Pune requirements can be managed through SSK Logistic for movement between factories, warehouses, markets, distribution centers, and business premises. Local transportation can support regular stock transfers, commercial deliveries, and short-distance cargo movement."
        },
        {
            "name": "Professional Transporters Pune",
            "description": "SSK Logistic supports professional transporters Pune requirements with organized transportation planning for commercial, industrial, and freight consignments. The service focuses on practical vehicle coordination, route scheduling, cargo movement, and destination delivery."
        },
        {
            "name": "Trusted Transporters Pune",
            "description": "Businesses searching for trusted transporters Pune can coordinate with SSK Logistic for goods movement, cargo transportation, industrial deliveries, freight movement, and commercial distribution. Service plans can be adapted to recurring routes and individual shipment requirements."
        },
        {
            "name": "Transportation Service Providers Pune",
            "description": "SSK Logistic supports transportation service providers Pune requirements with coordinated movement of goods, cargo, freight, machinery, and commercial inventory. Transportation arrangements can be structured around destination, cargo type, route distance, and required delivery schedules."
        },
        {
            "name": "Goods Transportation Services Pune",
            "description": "Goods transportation services Pune from SSK Logistic help manufacturers, distributors, retailers, wholesalers, and industrial businesses move products, raw materials, equipment, and inventory between business locations. Vehicle coordination and delivery schedules are planned according to shipment requirements."
        },
        {
            "name": "Freight Transportation Pune",
            "description": "Freight transportation Pune services from SSK Logistic support businesses moving heavier commercial and industrial consignments across local, regional, and interstate routes. Transportation planning considers freight size, vehicle suitability, loading requirements, and destination schedules."
        },
        {
            "name": "Cargo Transportation Pune",
            "description": "SSK Logistic provides cargo transportation Pune support for machinery, industrial materials, commercial products, warehouse inventory, equipment, and other business consignments. Cargo movement is coordinated around pickup schedules, route planning, vehicle requirements, and delivery locations."
        },
        {
            "name": "Industrial Transportation Pune",
            "description": "Industrial transportation Pune services from SSK Logistic support manufacturing units and industrial businesses moving raw materials, machinery, components, equipment, and finished products. Transportation arrangements can be coordinated according to production schedules and dispatch requirements."
        },
        {
            "name": "Transport Company Pune",
            "description": "SSK Logistic serves as a transport company Pune businesses can approach for organized freight, cargo, goods, truck, and industrial transportation. The service supports local and interstate routes with practical vehicle planning and coordinated delivery management."
        },
        {
            "name": "Transport Service Pune",
            "description": "Transport service Pune requirements can be coordinated through SSK Logistic for commercial inventory, industrial materials, machinery, freight, and cargo. Transportation is planned according to shipment characteristics, destination, route distance, and business scheduling needs."
        },
        {
            "name": "Reliable Transport Service Pune",
            "description": "Reliable transport service Pune support from SSK Logistic helps businesses manage recurring and one-time cargo movement requirements through organized route planning, vehicle coordination, pickup scheduling, and destination delivery arrangements."
        }
    ],

    "tableData": [
        ["Transporters in Pune", "Best Transporters in Pune"],
        ["Transporters Near Pune", "Reliable Transporters Pune"],
        ["Goods Transporters Pune", "Truck Transporters Pune"],
        ["Freight Transporters Pune", "Cargo Transporters Pune"],
        ["Industrial Transporters Pune", "Commercial Transporters Pune"],
        ["Container Transporters Pune", "Road Transporters Pune"],
        ["Heavy Transporters Pune", "Full Truck Load Transporters Pune"],
        ["Local Transporters Pune", "Professional Transporters Pune"],
        ["Trusted Transporters Pune", "Transportation Service Providers Pune"],
        ["Goods Transportation Services Pune", "Freight Transportation Pune"],
        ["Cargo Transportation Pune", "Industrial Transportation Pune"],
        ["Transport Company Pune", "Transport Service Pune"],
        ["Reliable Transport Service Pune", "Transporters in Pune"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Organized Transportation Coordination",
            WhyChoosedescription: "SSK Logistic coordinates goods movement through planned vehicle arrangements, route scheduling, pickup management, and delivery coordination, helping businesses maintain a more structured transportation process."
        },
        {
            WhyChooseheading: "Support for Industrial Cargo",
            WhyChoosedescription: "Manufacturing units and industrial businesses can arrange transportation for machinery, components, raw materials, equipment, and finished products with movement plans suited to their operational requirements."
        },
        {
            WhyChooseheading: "Flexible Truck Transportation",
            WhyChoosedescription: "Transportation can be planned according to cargo quantity and vehicle requirements, supporting commercial loads, freight consignments, truck transportation, container movement, and dedicated full truck load shipments."
        },
        {
            WhyChooseheading: "Local and Long-Distance Routes",
            WhyChoosedescription: "SSK Logistic supports transportation within Pune and nearby industrial regions along with longer routes to major commercial and manufacturing destinations across Maharashtra and other parts of India."
        },
        {
            WhyChooseheading: "Dedicated FTL Movement",
            WhyChoosedescription: "Businesses with larger consignments can coordinate dedicated full truck load transportation based on shipment volume, loading requirements, route distance, destination, and planned delivery schedules."
        },
        {
            WhyChooseheading: "Commercial Goods Support",
            WhyChoosedescription: "Retailers, wholesalers, distributors, and corporate businesses can use transportation support for inventory transfers, warehouse movements, commercial deliveries, and recurring distribution requirements."
        },
        {
            WhyChooseheading: "Practical Route Planning",
            WhyChoosedescription: "Each shipment is considered according to origin, destination, cargo characteristics, route distance, vehicle suitability, and delivery schedule, allowing SSK Logistic to coordinate practical transportation arrangements."
        },
        {
            WhyChooseheading: "Business-Focused Transport Service",
            WhyChoosedescription: "SSK Logistic focuses on the transportation needs of manufacturers, industrial units, warehouses, traders, distributors, and corporate businesses, supporting both recurring routes and individual cargo movement requirements."
        }
    ]

};















const faqData = [
    {
        question: "What transportation support does SSK Logistic provide in Pune?",
        answer: "SSK Logistic helps businesses manage the movement of commercial and industrial goods from Pune to different destinations, with transportation arrangements planned according to cargo specifications, route, vehicle capacity, and delivery requirements."
    },
    {
        question: "Can SSK Logistic transport goods from Pune to different cities?",
        answer: "Yes, businesses can arrange cargo transportation from Pune to locations such as Mumbai, Nashik, Nagpur, Ahmedabad, Surat, Indore, Bengaluru, Hyderabad, Chennai, Delhi, Jaipur, and several other destinations."
    },
    {
        question: "What types of goods can be transported through SSK Logistic?",
        answer: "Depending on the shipment requirements, transportation can be arranged for machinery, industrial materials, commercial stock, equipment, packaged products, raw materials, finished goods, supplies, and other suitable consignments."
    },
    {
        question: "Can SSK Logistic support regular transportation requirements?",
        answer: "Businesses that need frequent goods movement can discuss recurring transportation arrangements based on their regular routes, shipment volume, pickup schedules, vehicle requirements, and delivery timelines."
    },
    {
        question: "How does SSK Logistic determine the right transport vehicle?",
        answer: "Vehicle selection is planned after considering the cargo's weight, dimensions, quantity, volume, loading requirements, material type, travel distance, and destination."
    },
    {
        question: "Can I arrange a transporter from Pune to Mumbai through SSK Logistic?",
        answer: "Pune to Mumbai goods movement can be coordinated for suitable commercial and industrial shipments, including business stock, equipment, machinery, supplies, packaged goods, and other cargo."
    },
    {
        question: "Does SSK Logistic provide interstate transportation from Pune?",
        answer: "Interstate transportation can be planned from Pune toward destinations across states such as Gujarat, Madhya Pradesh, Karnataka, Telangana, Tamil Nadu, Rajasthan, and other parts of India."
    },
    {
        question: "Are SSK Logistic transportation services suitable for industrial businesses?",
        answer: "Manufacturers, suppliers, distributors, warehouses, and industrial companies can use transportation support for moving raw materials, finished products, machinery, equipment, inventory, and other business-related goods."
    },
    {
        question: "Can SSK Logistic arrange transportation according to specific cargo requirements?",
        answer: "Transportation planning can be tailored around the pickup point, destination, type of goods, shipment quantity, vehicle capacity, loading conditions, preferred delivery schedule, and recurring movement requirements."
    },
    {
        question: "What information is needed to request transportation from SSK Logistic in Pune?",
        answer: "To discuss a suitable transporter arrangement, share the pickup location, delivery destination, cargo type, approximate weight or quantity, loading details, vehicle preference, and required delivery timeframe."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Harshad Shinde",
        feedback: "Our company needed a transporter for moving finished goods from Pune to Indore. SSK Logistic understood the shipment details and coordinated the transportation according to our business requirements.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Priyanka Salunkhe",
        feedback: "We used SSK Logistic for transporting commercial materials from Pune to Surat. The team was easy to coordinate with, and the vehicle arrangement was handled according to the quantity and type of our shipment.",
        rating: 5
    }
];














    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Transporters in Pune",
  "image": "https://ssklogistics.in/assets/images/transporters-in-pune.webp",
  "description": "SSK Logistics provides organized transportation support for businesses searching for transporters in Pune for goods movement, freight transportation, commercial shipments and industrial cargo requirements. Transporters in Pune can assist manufacturers, distributors, wholesalers, retailers, warehouses and businesses with moving goods between factories, suppliers, storage facilities, distribution centres and customer locations. Businesses searching for best transporters in Pune often require suitable vehicles, dependable coordination and transportation arrangements based on cargo type, route and delivery schedule. Transporters Near Pune can support businesses requiring goods movement around Pune and nearby industrial or commercial locations. Reliable transporters Pune services can be planned for regular shipments as well as individual commercial consignments. Goods transporters Pune can assist with the movement of business products, raw materials, equipment, machinery and other commercial goods. Truck transporters Pune are suitable for shipments requiring larger commercial vehicles and dedicated goods transportation, while freight transporters Pune can support businesses handling regular or project-based freight movement. SSK Logistics can coordinate transportation requirements according to shipment volume, vehicle capacity, destination and preferred delivery schedule. The service can support local, regional and interstate goods movement, making it suitable for businesses looking for practical transportation assistance and dependable logistics coordination across Pune and connected routes.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Transport Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/transporters-in-pune"
  }
};


    return (
        <div>

<Helmet>
  <title>
    Transporters in Pune | Reliable Goods, Truck & Freight Transportation Services | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics provides reliable transporters in Pune for goods transportation, truck transport, freight movement, commercial shipments and industrial cargo."
  />

  <meta
    name="keywords"
    content="Transporters in Pune, transporters in pune, best transporters in pune, transporters near pune, reliable transporters pune, goods transporters pune, truck transporters pune, freight transporters Pune, goods transportation Pune, goods transport services Pune, truck transportation Pune, freight transportation Pune, cargo transporters Pune, cargo transportation Pune, commercial transporters Pune, commercial transportation Pune, industrial transporters Pune, industrial transportation Pune, logistics transporters Pune, transport service providers Pune, transportation service providers Pune, reliable transport company Pune, professional transporters Pune, local transporters Pune, regional transporters Pune, interstate transporters Pune, B2B transporters Pune, business transporters Pune, warehouse transporters Pune, warehouse goods transportation Pune, heavy goods transport Pune, commercial goods transport Pune, dedicated transport Pune, freight service provider Pune, cargo service provider Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Transportinpune;